// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39a_U","top":"styles_top__NUwGH","left":"styles_left__SBVfX","description":"styles_description__1zaGY"};